import { createFileRoute, redirect } from '@tanstack/react-router';

import { getAuthSession, Logout } from '@/features/auth';
import { isIframeWindow } from '@/shared/utils/utils';

export const Route = createFileRoute('/auth/_authLayout/logout')({
  beforeLoad: async () => {
    if (isIframeWindow()) {
      redirect({ to: '/', throw: true, replace: true });
      return;
    }

    const session = await getAuthSession();
    if (!session) {
      redirect({ to: '/auth/login', replace: true, throw: true });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <Logout />;
}
